import { Layout } from 'antd';
import styled from 'styled-components';

const { Header, Content } = Layout;

export const StyledLayout = styled(Layout)`
  background: #f1f5f9 !important;
`;

export const StyledBackgroundImage = styled.img`
  position: absolute;
  z-index: 0;
  width: 100%;
  top: 60px;
  height: 250px;
  object-fit: cover;
`;

export const StyledHeader = styled(Header)`
  display: flex;
  align-items: center;
  background: #ffffff !important;
  padding: 0 16px;
`;

export const StyledOuterLayout = styled(Layout)`
  min-height: 100vh;
`;

export const StyledContent = styled(Content)`
  margin-top: 35px;
`;

export const StyledSideNavigationBackButtonContent = styled.span`
  .prefix {
    margin-left: 10px;
  }

  .link {
    color: #272793;
    margin-left: 5px;
  }
`;
